import React from "react";
import { Button } from "@mui/material";
import { API } from "aws-amplify";
import { useAppDispatch } from "store/hooks";
import { hideError, showError } from "store/reducers/errorReducer";
import { hideSpinner, showSpinner } from "store/reducers/spinnerReducer";

export const FileList = ({ files, referralId }) => {
  const dispatch = useAppDispatch();

  const downloadFile = async (fileId) => {
    dispatch(hideError());

    try {
      dispatch(hideError());
      dispatch(showSpinner());
      const result = await API.post(
        "restApiV2",
        `/referral/${referralId}/files/download/${fileId}`,
        {
          body: {
            dashboardAccessToken: null,
          },
          responseType: "blob",
        }
      );

      const file = files.find((file) => file.id === fileId);
      const fileName = file?.originalName;

      const blob = new Blob([result], {
        type: file.contentType ?? "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      showError(error?.message ?? "Something went wrong");
    } finally {
      dispatch(hideSpinner());
    }
  };

  return (
    <div className="bg-white flex flex-col p-4 divide-y border rounded-xl overflow-hidden">
      {files.map((file) => (
        <div
          key={file.id}
          className="p-4 text-left flex justify-between items-center"
        >
          <div>
            <p className="text-gray-800 font-medium">{file.originalName}</p>
            <p className="text-gray-600 text-sm">
              Created at: {new Date(file.createdAt).toLocaleString()}
            </p>
          </div>
          <p className="text-gray-600 text-sm">
            Size: {(file.contentLength / 1024).toFixed(2)} KB
          </p>
          <Button onClick={() => downloadFile(file?.id)}>Download</Button>
        </div>
      ))}
    </div>
  );
};
